import { shallowEqual } from 'react-redux';

import { AppState, useAppSelector } from '@redux/store';

export const useChannelDataById = (id?: string) =>
  useAppSelector(
    ({ channels }: AppState) => (id ? channels.byId[id] : null),
    shallowEqual,
  );
